import { gql, useMutation, useQuery } from "@apollo/client";
import { ContractorUserView, Modal } from "components";
import { FC } from "react";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { withRoles, wrapClick } from "utils";
import { GET_CONTRACTOR_USER } from "./view";

const ENABLE_METER_CONTRACTOR_USER = gql`
  mutation EnablePartnerUser($id: ID!) {
    enablePartnerUser(id: $id) {
      _id
    }
  }
`;

interface EnablePartnerUserContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}

const EnablePartnerUserContainer: FC<EnablePartnerUserContainerProps> = ({
  open,
  setOpen,
  refetch,
}) => {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_CONTRACTOR_USER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
  });

  const [enablePartnerUser, { loading: loadingEnable }] = useMutation(
    ENABLE_METER_CONTRACTOR_USER,
  );

  const deleteItem = async () => {
    await enablePartnerUser({
      variables: {
        id: searchParams.id,
      },
    }).then(({ data }) => {
      if (data?.enablePartnerUser?._id) {
        toast(
          JSON.stringify({
            type: "success",
            title: "User Enabled Successfully",
          }),
        );
        refetch?.();
        setOpen(false);
      } else {
        toast(
          JSON.stringify({ type: "error", title: "Could not enable User" }),
        );
      }
    });
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Enable User"
      description="Are you sure you want to enable this user?  "
      renderActions={() => (
        <>
          {withRoles(["Super"])(
            <button
              type="button"
              disabled={loadingEnable}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={wrapClick(deleteItem)}
            >
              {loadingEnable ? "Enabling User..." : "Enable User"}
            </button>,
          )}
        </>
      )}
    >
      {data?.user?._id && <ContractorUserView user={data?.user} />}
    </Modal>
  );
};

export default EnablePartnerUserContainer;
